import * as React from "react";

const IconPlus: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="currentColor"><path fill="currentColor" fillRule="evenodd" d="M6,0 L6,4 L10,4 L10,6 L6,6 L6,10 L4,10 L4,6 L0,6 L0,4 L4,4 L4,0 L6,0 Z"/></svg>;
};

export default React.memo(IconPlus);
